import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import test from '../components/test'
Vue.use(VueRouter)

let router = new VueRouter({
  linkExactActiveClass: 'active',
  routes: [
   
    {
      path: "/Login",
      name: "Login",
      component: () => import('../views/Login'),
      meta: { requiresAuth: false }

    },
    {
			path: '/profile',
			name: 'profile',
			component: () => import('../views/appAccountSetting')
		},

    {
      path: "/",
      redirect: 'Dashboard',
      component: () => import('../views/appDashboard'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: test
        },
        {
          path: '/ConservationTechnology',
          name: 'ConservationTechnologyEditor',
          props: true,
          component: () => import('../components/ProjectCategory/ConservationTechnology')
        },

        {
          path: '/EnterpriseSolutions',
          name: 'EnterpriseSolutionsEditor',
          props: true,
          component: () => import('../components/ProjectCategory/EnterpriseSolutions')
        },
        {
          path: '/ITConsultancyService',
          name: 'ITConsultancyServiceEditor',
          props: true,
          component: () => import('../components/ProjectCategory/ITConsultancyService')
        },
        {
          path: '/Research&Development',
          name: 'Research&DevelopmentEditor',
          props: true,
          component: () => import('../components/ProjectCategory/Research&Development')
        },

        {
          path: '/Contactus',
          name: 'Contactus',
          props: true,
          component: () => import('../components/Contact/ContactUslist.')
        },
        
        {
					path: '/ViewContactUs/:id',
					name: 'ViewContactUs',
					props: true,
					component: () => import('../components/Contact/ViewContactUs')
        },

        {
          path: '/Projects',
          name: 'Projects',
          component: () => import('../components/Projects/ProjectsList')
        },

        {
          path: '/AddProject',
          name: 'AddProject',
          component: () => import('../components/Projects/AddProject')
        },

        {
          path: '/ViewProject/:id',
          props:true,
          name: 'ViewProject',
          component: () => import('../components/Projects/ViewProject')
        }, 

        {
          path: '/EditProject/:id',
          props:true,
          name: 'EditProject',
          component: () => import('../components/Projects/EditProject')
        }, 
        
        {
          path: '/Team',
          name: 'Team',
          props: true,
          component: () => import('../components/Team/Teamlist')
        },
    
        {
          path: '/AddTeamMember',
          name: 'AddTeamMember',
          component: () => import('../components/Team/AddTeamMember')
        },

        {
          path: '/ViewTeamMember/:id',
          props:true,
          name: 'ViewTeamMember',
          component: () => import('../components/Team/ViewTeamMember')
        }, 

        {
          path: '/EditTeamMember/:id',
          props:true,
          name: 'EditTeamMember',
          component: () => import('../components/Team/EditTeamMember')
        }, 

        {
          path: '/Partners',
          name: 'Partners',
          component: () => import('../components/Partners/Partners')
        },
        
        {
          path: '/EditPartner/:id',
          props:true,
          name: 'EditPartner',
          component: () => import('../components/Partners/EditPartner')
        },

        {
          path: '/ViewPartner/:id',
          props:true,
          name: 'ViewPartner',
          component: () => import('../components/Partners/ViewPartner')
        },

        {
          path: '/Interntraining',
          name: 'Interntraining',
          props: true,
          component: () => import('../components/Internship/InternTraininglist')
        },
        {
					path: '/InternTraineedetail/:id',
					name: 'InternTraineedetail',
					props: true,
					component: () => import('../components/Internship/InternTraineeDetail')
        },
        {
          path: '/Careers',
          name: 'Careers',
          props: true,
          component: () => import('../components/Careers/applications')
        },
        {
					path: '/Applicantdetail/:id',
					name: 'Applicantdetail',
					props: true,
					component: () => import('../components/Careers/Applicantdetail')
        },
      ]

    },

   

  ]
})

router.beforeEach((to, from, next) => {

  //check if the route requires authentication and user is not logged in
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    // redirect to login page
    next({ name: 'Login' })
    return
  }
  
  //if logged in redirect to dashboard
  if (to.path === '/Login' && store.state.isLoggedIn) {
    next({ name: 'Dashboard' })
    return
  }
  
  next()
  })

export default router
